import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
} from '@angular/core';

export type DashboardStatTone = 'amber' | 'blue' | 'green';

/**
 * Presentational KPI card for the admin dashboard (icon well + number + label).
 * The icon is content-projected via `[icon]` so the container owns the inline SVG.
 */
@Component({
  selector: 'em-dashboard-stat-card',
  templateUrl: './dashboard-stat-card.component.html',
  styleUrls: ['./dashboard-stat-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardStatCardComponent {
  /** Null while the backing request is in flight → renders an em dash. */
  readonly value = input<number | string | null>(null);
  readonly label = input.required<string>();
  /** Icon-well tint. */
  readonly tone = input<DashboardStatTone>('blue');
  /** Emphasise the card with a 4px left accent border. */
  readonly accent = input(false, { transform: booleanAttribute });
}
